import muster from '@dbk-legacy/muster';
import { variable } from '@dbk-legacy/muster/helpers';
import { getValues } from '@dbk-legacy/muster/utils';
import Guid from '../utils/guid';
import { VASCO_FLOW, VASCO_MODAL_TYPES, INVALID_TRANSACTION_LIMIT_CODE, INVALID_TRANSACTION_LIMIT_DESCRIPTION, MAX_TRANSACTION_LIMIT_EXCEEDED_DESCRIPTION } from '../constants';

const { Base64 } = require('js-base64');

const USERPROFILE_PATH = 'roster.data.userprofile';

export default () => muster()
  .path('sepaLimit.getSepaIpLimit', {
    call: async ({ req }, { get, set, call }) => {
      let messages;
      try {
        [messages] = await getValues(get('i18n.messages'));
        const [userId] = await getValues(get('auth.userId'));
        const request = {
          userId
        };
        const requestObj = Base64.encode(JSON.stringify(request));
        await set('sepaLimit.blurModalError', null);

        const [result] = await getValues(get(`${USERPROFILE_PATH}.getSepaIpLimit["${requestObj}"]["${Guid()}"]`));
        const data = JSON.parse(result);

        if (data) {
          await set('sepaLimit.sepaTransactionLimit', data.transactionLimit);
          await set('sepaLimit.maxSepaTransactionLimit', data.maxTransactionLimit);
        } else {
          await set(
          'sepaLimit.blurModalError',
          messages['app.chedelivery.reports.systemErrorMessage']
        );
        }
      } catch (e) {
        await set('sepaLimit.sepaTransactionLimit', null);
        await set('sepaLimit.maxSepaTransactionLimit', null);
        await set(
          'sepaLimit.blurModalError',
          messages['app.chedelivery.reports.systemErrorMessage']
        );
      }
    }
  })

  .path('sepaLimit.saveSepaIpLimit', {
    call: async ({ req }, { get, set, call }) => {
      const [messages] = await getValues(get('i18n.messages'));
      const [userId] = await getValues(get('auth.userId'));
      const sepaTransactionLimit = req.args[0] ?? (await getValues(get('sepaLimit.sepaTransactionLimit')))?.[0];
      const request = {
        userId,
        transactionLimit: sepaTransactionLimit,
      };
      const requestObj = Base64.encode(JSON.stringify(request));

      try {
        await set('sepaLimit.blurModalError', null);
        const [result] = await getValues(get(`${USERPROFILE_PATH}.saveSepaIpLimit["${requestObj}"]["${Guid()}"]`));
        const data = JSON.parse(result);

        if (Number(data?.transactionLimit) === Number(sepaTransactionLimit)) {
          await set('sepaLimit.sepaTransactionLimit', data.transactionLimit);
          return { response: true };
        }

        if (
          data?.code === INVALID_TRANSACTION_LIMIT_CODE &&
          data?.description === INVALID_TRANSACTION_LIMIT_DESCRIPTION
        ) {
          await set('sepaLimit.blurModalError', messages['app.sepaip.limit.zero.message']);
          return { response: false };
        }

        if (
          data?.code === INVALID_TRANSACTION_LIMIT_CODE &&
          data?.description === MAX_TRANSACTION_LIMIT_EXCEEDED_DESCRIPTION
        ) {
          await set('sepaLimit.blurModalError', messages['app.sepaip.limit.maximum.exceeded.message']);
          return { response: false };
        }

        await set('sepaLimit.blurModalError', messages['app.chedelivery.reports.systemErrorMessage']);
        return { response: false };
      } catch (e) {
        await set('sepaLimit.blurModalError', messages['app.chedelivery.reports.systemErrorMessage']);
        return { response: false };
      }
    }
  })
  .path('sepaLimit.startOtpVerification', {
    call: async ({ req }, { get, set, call }) => {
      await set('auth.vascoFlow', VASCO_FLOW.browser);
      await set('sepaLimit.isSaveSepaLimitOtpPending', true);
      await set('sepaLimit.isSepaLimitOtpVerified', false);
      await set('vascoauthentication.varifyOtpRandomNumber',  "random" + Math.round(Math.random() * 1000));
      await set('vascoauthentication.vascoVisible', true);
      await set('vascoauthentication.vascoModalType', VASCO_MODAL_TYPES.pin2fa);
    }
  })
  .path('sepaLimit.resetOtpState', {
    call: async ({ req }, { get, set, call }) => {
      await set('sepaLimit.isSaveSepaLimitOtpPending', false);
      await set('sepaLimit.isSepaLimitOtpVerified', false);
    }
  })
  .path('sepaLimit.blurModalError', variable(null))
  .path('sepaLimit.sepaTransactionLimit', variable(null))
  .path('sepaLimit.maxSepaTransactionLimit', variable(0))
  .path('sepaLimit.isSaveSepaLimitOtpPending', variable(false))
  .path('sepaLimit.isSepaLimitOtpVerified', variable(false))